/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ModalController } from '@ionic/angular';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-preface',
  templateUrl: './modal-preface.component.html',
  styleUrls: ['./modal-preface.component.scss'],
  standalone: false
})
export class ModalPrefaceComponent {
  @Input() title: string;

  @Input() messages: string[] = [];

  @Input() figure: string;

  @Input() okText: string;

  constructor(private modalController: ModalController) {}

  async close(): Promise<void> {
    await this.modalController.dismiss();
  }
}
